module.exports = __webpack_public_path__ + "static/media/pep-circle-skireisen.068cbb99.png";